// @ts-nocheck
import * as keyPoolNotificationsApi from '../api/keyPoolNotificationsApi';

export function saveKeyPoolNotification(keyPoolNotifications) {
  return keyPoolNotificationsApi.saveKeyPoolNotification(keyPoolNotifications);
}

export function getKeyPoolNotificationById(id) {
  return keyPoolNotificationsApi.getKeyPoolNotificationById(id);
}

export function loadKeyPoolNotifications(params) {
  return keyPoolNotificationsApi.getKeyPoolNotifications(params);
}

export function deleteKeyPoolNotification(id) {
  return keyPoolNotificationsApi.deleteKeyPoolNotification(id);
}

export function exportKeyPoolNotificationData(filters, scopes) {
  return keyPoolNotificationsApi.exportKeyPoolNotificationData(filters, scopes);
}
